import _curry from "ramda/es/curry";
import _complement from "ramda/es/complement";
import lensIsEmpty from './lensIsEmpty';

var lensIsNotEmpty = function (lens, obj) {
  return _complement(lensIsEmpty(lens))(obj);
};

export default _curry(lensIsNotEmpty);